export const settings = {
  SUPPORTED_LANGUAGES: ['en', 'fr', 'it'],
  SUPPORT_EMAIL: 'contact@restaudeal.com',
  
  DEFAULT_SEO_IMAGE: {
    "url": "./assets/img/logo-fb-share.png",
    "mimeType": "image/png",
  },
};
